import {getPreference, setPreference} from "./Preferences";
import {inject, injectable} from "inversify";
import {PubSub} from "../Core/PubSub";

export let settings: Settings = {
    creatorMode: <boolean> getPreference('creatorMode') || false,
    volume: <number> getPreference('volume') || 1,
    closedCaptions: <boolean> getPreference('closedCaptions') || false,
    readerMode: <boolean> getPreference('readerMode') || false,
    playbackSpeed: <0.5|0.75|1> getPreference('playbackSpeed') || 1,
    focusOutline: <string> getPreference('focusOutline') || "orange"
};

@injectable()
export class SettingsService {
    constructor(@inject("PubSub") private pubSub: PubSub) {}

    setSetting(setting: keyof Settings, value: any) {
        // @ts-ignore
        settings[setting] = value;
        setPreference(setting, value);
        return this.pubSub.publishEvent(SettingsEvents[setting], value);
    }
}

export enum SettingsEvents {
    creatorMode = "settings.creatorMode",
    volume = "settings.volume",
    closedCaptions = "settings.closedCaptions",
    readerMode = "settings.readerMode",
    playbackSpeed = "settings.playbackSpeed",
    focusOutline = "settings.focusOutline"
}

export interface Settings {
    creatorMode: boolean;
    volume: number;
    closedCaptions: boolean;
    readerMode: boolean;
    playbackSpeed: 0.5|0.75|1;
    focusOutline: string;
}